import { useState } from 'react';
import classes from './AmendScheduleDialog.module.css';
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'

export const AmendScheduleDialog = ({ showAmend, setShowAmend, pinNames, scheduleID, tempTriggerTime, setTempTriggerTime, amendSchedule, showSuccess, setShowSuccess, showFail, setShowFail, successType, OverrideSchedule }) => {
    const [showTimeDialog, setShowTimeDialog] = useState(false);

    const now = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
    console.log('time', now);
    return (
    <>
        <Dialog
            header="Amend Schedule"
            visible={showAmend}
            style={{ width: "30vw"}}
            onHide={() => setShowAmend(false)}
        >
            <div className={classes.container}>
                <h4>NOTE: This will only adjust the schedule for today. To make permanent changes, please edit from within the rules section</h4>
                <h4>Affected Schedules: <br /><span style={{}}>{pinNames}</span></h4>
                <div className={classes.btnList}>
                    <Button type='button' label='Amend time for today' severity="secondary" onClick={() => { setShowTimeDialog(true); setShowAmend(false); }} />
                    {/* <Button type='button' label='Ignore schedule for today' severity="secondary" onClick={() => {OverrideSchedule(scheduleID); setShowAmend(false);}}/> */}
                </div>
            </div>
        </Dialog>

        <Dialog
            header='Set New Time'
            visible={showTimeDialog}
            style={{ width: '25vw'}}
            onHide={() => {setShowTimeDialog(false); setTempTriggerTime(null); }}
        >
            <div className={classes.container}>
                <Calendar
                    placeholder={now}
                    value={tempTriggerTime}
                    onChange={(e) => setTempTriggerTime(e.value)}
                    timeOnly
                />
                <div className={classes.btnRow}>
                    <Button 
                        type='button' 
                        label='Cancel' 
                        className={classes.cancelBtn} 
                        onClick={() => {
                            setShowTimeDialog(false);
                            setTempTriggerTime(null);
                        }}/>
                    <Button
                        type='button'
                        label='Set'
                        severity='secondary'
                        onClick={() => {
                            amendSchedule(scheduleID, tempTriggerTime);
                            setShowTimeDialog(false);
                            }}
                        />
                </div>
            </div>
        </Dialog>

        {/* success/are you sure blueprint */}
        <Dialog
            header='Success'
            visible={showSuccess}
            style={{ width: '25vw'}}
            onHide={() => setShowSuccess(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "32px" }}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 90, height: 90, margin: "0px" }}
                    />
                    <h3 style={{color: "rgb(147, 147, 147)", fontWeight: "500", fontSize: "16px", margin: "0" }}>
                        {successType === 'Amend' ? 'Schedule amended successfully!' : 
                        successType=== 'Ignore' ? 'Schedule ignored for today!' : 'Successful!'}
                    </h3>
                </div>

                <Button style={{ width: "100%" }}label="Close" severity="secondary" onClick={() => setShowSuccess(false)}/>
            </div>
        </Dialog>

        <Dialog
            header='Error'
            visible={showFail}
            style={{ width: '25vw' }}
            onHide={() => setShowFail(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => setShowFail(false)}/>
            </div>

        </Dialog>
    </>
    )
}